module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter04"
    }
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_vm._v("CHRISTMAS")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kurt Tucholsky")])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0011-01.jpg",
      "width": "10%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Thus standing ’fore the German rubble")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I meekly sing my Christmas song.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I’ll neither heed nor need to trouble")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("with all the wide world’s right and wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That’s for others. Laid upon us.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I hum so soft, the sound near gone,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("that tune with all its youthful promise:")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("O Tannenbaum!")])]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Were I Knecht Ruprecht spreading blessings")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("and saw this pandemonium")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("—the Germans have no use for lessons—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("God knows! I’d turn the way I’d come.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The last of the breadcorn’s falling, blighted.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The alleys bare their teeth and foam.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I’d drape them from your boughs delighted,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("O Tannenbaum!")])]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I stare into the candles crackling:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who holds the guilt that runs so deep?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who threw us into blood, and cackling?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Us Germans, patient as the sheep?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("They do not mourn. They man their station.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I dreamt my dream I thought was gone")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Close off and cease their arrogation!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Ignore the scoundrels’ cruel predation!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Then sing with Christmas liberation:")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("O Tannenbaum! O Tannenbaum!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1918")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8babfcdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_Chapter04.vue
// module id = 81
// module chunks = 0